import { useCallback, useState } from 'react'
import Project from 'common/project'
import _data from 'common/utils/_data'

interface Occupation {
  value: string
  label: string
}

export const useGetOccupations = () => {
  const [occupations, setOccupations] = useState<Occupation[]>([])
  const loadOccupations = useCallback(() => {
    _data
      .get(`${Project.liveApi}users/occupations/`)
      .then((data) =>
        setOccupations(
          data.map((occupation: { id: string; name: string }) => ({
            value: occupation.id,
            label: occupation.name,
          }))
        )
      )
  }, [])

  return {
    occupations,
    loadOccupations,
  }
}
